import { CarrierCookieChecker } from '@shipstation/connections-ui';
import { defineMessages, FormattedMessage } from 'react-intl';
import React, { useEffect, useCallback } from 'react';

import {
  NotificationService,
  NOTIFICATION_TYPE_ERROR,
  NOTIFICATION_TYPE_SUCCESS,
  NOTIFICATION_DURATIONS,
} from 'ui-components/services/notification-service';

const messages = defineMessages({
  successTitle: {
    description: 'Success',
    defaultMessage: 'Success',
    id: 'yg2HFT',
  },
  successBody: {
    description: 'Successfully added carrier',
    defaultMessage: 'Successfully added {carrierName}.',
    id: 'x0huuC',
  },
  errorTitle: {
    description: 'Error',
    defaultMessage: 'Error',
    id: '6/PjjV',
  },
  errorBody: {
    description: 'Failed to add carrier',
    defaultMessage: 'Failed to add {carrierName}. Please try again.',
    id: 'vXqi4d',
  },
  defaultCarrierName: {
    description: 'Default carrier name',
    defaultMessage: 'your carrier',
    id: 'oHrrQO',
  },
});

export const useCarrierCookieChecker = () => {
  const getDefaultCarrierName = (data) => data?.name || <FormattedMessage {...messages.defaultCarrierName} />;

  const showNotification = useCallback((type, titleMessage, bodyMessage, data) => {
    const carrierName = getDefaultCarrierName(data);

    NotificationService.showNotification({
      notificationType: type,
      title: <FormattedMessage {...titleMessage} />,
      content: <FormattedMessage {...bodyMessage} values={{ carrierName }} />,
      duration: NOTIFICATION_DURATIONS.MEDIUM,
    });
  }, []);

  useEffect(() => {
    CarrierCookieChecker({
      onSuccess: (data) => showNotification(NOTIFICATION_TYPE_SUCCESS, messages.successTitle, messages.successBody, data),
      onFailure: (data) => showNotification(NOTIFICATION_TYPE_ERROR, messages.errorTitle, messages.errorBody, data),
    });
  }, [showNotification]);
};
